// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pq-5";
export var filledCircle = "_pq-4";
export var historyEntry = "_pq-3";
export var messageSideLeft = "_pq-1";
export var messageSideRight = "_pq-2";
export var orderTrackingCarouselWrapper = "_pq-6";
export var orderTrackingInfoContainer = "_pq-0";